import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { useAppSelector } from 'redux/hooks';
import { setThemeSet, THEME_SETS } from 'redux/theme/reducer';
import { ReactComponent as ShowListIcon } from "assets/icons/new/UI/ShowList.svg";
import { useEffect, useRef } from 'react';
import { useUserSettings } from 'hooks/useUserSettings';

const selectConfig = () => ({
  searchClasses: "block w-full sm:text-[13px]",
  searchWrapperClasses: "-mx-1 sticky top-0",
  toggleTag: "<button type=\"button\" aria-expanded=\"false\"><div data-icon></div></button>",
  toggleClasses: "hs-select-disabled:pointer-events-none hs-select-disabled:opacity-50 relative flex items-center gap-x-2 text-nowrap w-full cursor-pointer text-start text-[13px] mr-[5px] focus:outline-hidden",
  dropdownClasses: `!visible mt-1 z-80 w-full max-h-72 space-y-0.5 z-50 overflow-hidden overflow-y-auto shadow-2xl border border-theme-border dark:border-theme-border bg-theme-bg dark:bg-theme-bg rounded-xl [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-track]:bg-gray-100 [&::-webkit-scrollbar-thumb]:bg-gray-300 dark:[&::-webkit-scrollbar-track]:bg-neutral-700 dark:[&::-webkit-scrollbar-thumb]:bg-neutral-500 fixed`,
  optionClasses: `py-2 px-1 w-full text-[13px] cursor-pointer rounded-lg hover:bg-theme-hover dark:hover:bg-theme-hover hover:text-theme-color-active dark:hover:text-theme-color-active focus:outline-hidden`,
  optionTemplate: "<div><div class=\"flex items-center gap-x-2\"><div data-icon></div><div className=\"overflow-hidden text-ellipsis max-w-full\" data-title></div><span class=\"hidden hs-selected:block ms-auto\"><svg class=\"shrink-0 size-3.5 \" xmlns=\"http:.w3.org/2000/svg\" width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" strokeWidth=\"2\" strokeLinecap=\"round\" strokeLinejoin=\"round\"><polyline points=\"20 6 9 17 4 12\"/></svg></span></div></div>",
  dropdownScope: "window",
  viewport: "#hs-pro-shmnrsm-body",
});

const ThemeSelector = () => {
  const selectRef = useRef<HTMLDivElement>(null)
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { currentThemeSet } = useAppSelector((state) => state.theme);
  const { updateSettings } = useUserSettings()

  const handleThemeSelect = (themeSetId: string) => {
    dispatch(setThemeSet(THEME_SETS[themeSetId as keyof typeof THEME_SETS]));
    updateSettings({ colorSet: themeSetId })
  };

  useEffect(() => {
    setTimeout(() => {
      (window as any).HSStaticMethods?.autoInit?.();
    }, 100)
  }, [])

  const clickFn = () => {
    selectRef.current?.querySelector('button')?.click()
  }

  return (
    <div className="relative mr-[8px]" ref={selectRef}>
      <select
        data-hs-select={JSON.stringify(selectConfig())}
        className="hidden"
        onChange={(e) => handleThemeSelect(e.target.value)}
      >
      <option value="">Choose</option>
        {Object.values(THEME_SETS).map((themeSet) => (
          <option value={themeSet.id} selected={currentThemeSet.id === themeSet.id}>
            {t(themeSet.name)}
          </option>
        ))}
      </select>

      <div className="absolute top-1/2 end-[-11px] -translate-y-1/2 cursor-pointer" onClick={clickFn}>
        <ShowListIcon width="24" height="24" fill="currentColor" className="shrink-0 size-3.5" />
      </div>
    </div>
  );
};

export default ThemeSelector;